import { useEffect, useMemo, useState } from 'react';


/** Returns the start of the day 7 days ago */
export const useSevenDaysAgo = () => {
    const [today, setToday] = useState(new Date());

    // Update date when day changes
    useEffect(() => {
        const getStartOfTomorrow = () => {
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            tomorrow.setHours(0, 0, 0, 0);
            return tomorrow;
        };

        const timeUntilMidnight = getStartOfTomorrow().getTime() - new Date().getTime();
        const timer = setTimeout(() => setToday(new Date()), timeUntilMidnight);

        return () => clearTimeout(timer);
    }, [today]);

    // Calculate start of day 7 days ago
    const startOfDaySevenDaysAgo = useMemo(() => {
        const date = new Date(today);
        date.setDate(date.getDate() - 7);
        date.setHours(0, 0, 0, 0);
        return date;
    }, [today]);

    return startOfDaySevenDaysAgo;
};
